import { DocumentNode, gql } from "@apollo/client";

export interface MpxAddressSuggestion {
  id: string;
  address: string;
}

export interface Point {
  lat: number;
  lng: number;
}

export enum ProblemMessages {
  NONE = "NONE",
  ADDRESS_NOT_FOUND = "ADDRESS_NOT_FOUND",
  MISMATCH = "MISMATCH",
  INTERPOLATED = "INTERPOLATED",
  MISSING_TIMEZONE = "MISSING_TIMEZONE",
  ADDRESS_ERROR = "ADDRESS_ERROR",
  ZIP_ONLY = "ZIP_ONLY",
}

export interface GeocodedAddress {
  street1?: string;
  street2?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  coords?: Point;
  timezone?: string;
  problem: boolean;
  problemMessage: ProblemMessages;
}

export interface BaseAddressDTO {
  street1?: string;
  street2?: string;
  state?: string;
  city?: string;
  zipCode?: string;
  country?: string;
  placeId?: string;
}

class MpxService {
  public static suggestAddress = (): DocumentNode => gql`
    query SuggestAddress($address: String!) {
      suggestAddress(address: $address) {
        id
        address
      }
    }
  `;

  public static getAddressByPlaceId = (): DocumentNode => gql`
    query GetAddressByPlaceId($placeId: String!) {
      getAddressByPlaceId(placeId: $placeId) {
        street1
        street2
        city
        state
        zipCode
        country
        coords {
          lat
          lng
        }
        timezone
        problem
        problemMessage
      }
    }
  `;

  public static geocodeAddress = (): DocumentNode => gql`
    query GeocodeAddress($address: BaseAddressDTO!) {
      geocodeAddress(address: $address) {
        street1
        street2
        city
        state
        zipCode
        country
        coords {
          lat
          lng
        }
        timezone
        problem
        problemMessage
      }
    }
  `;
}

export default MpxService;
